import React from 'react';
import Switch from 'react-switch';

export interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const WorkingHoursSwitch: React.FC<Props> = ({ checked, onChange }) => (
  <div
    className="flex px-3 pb-6 items-center mb-6 border-b border-gray-350"
    style={{ borderBottomWidth: 0.5 }}
  >
    <Switch
      checked={checked}
      checkedIcon={
        <div className="flex justify-center items-center h-full">
          <p className="font-extrabold text-white text-xs leading-4">ON</p>
        </div>
      }
      handleDiameter={22}
      offColor="#B3C1D2"
      offHandleColor="#EBEBEB"
      onColor="#2D80E2"
      onHandleColor="#EBEBEB"
      onChange={onChange}
      uncheckedIcon={
        <div className="flex justify-center items-center h-full">
          <p className="font-extrabold text-gray-700 text-xs leading-4">OFF</p>
        </div>
      }
      width={60}
    />

    <p className="ml-3 text-gray-600 font-extrabold text-sm">
      Show times outside of my working hours
    </p>
  </div>
);

export default WorkingHoursSwitch;
